module.exports = __webpack_public_path__ + "media/images/product-img-03-44fd6069b94a3167c04dc84bf078fbee.jpg";